import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import VendorsList from './VendorsList';
import PendingVendors from './PendingVendors';
import './PartnerPanel.css';

const PartnerPanel = () => {
  const [tab, setTab] = useState('vendors');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('partner_token');
    if (!token) {
      navigate('/partner/login');
    }
  }, [navigate]);

  return (
    <div className="partner-panel-container">
      <div className="partner-panel-tabs">
        <button
          className={tab === 'vendors' ? 'active' : 'inactive'}
          onClick={() => setTab('vendors')}
        >
          Vendors
        </button>
        <button
          className={tab === 'pending' ? 'active' : 'inactive'}
          onClick={() => setTab('pending')}
        >
          Vendors Approved Status
        </button>
      </div>
      <div className="partner-panel-content">
        {tab === 'vendors' && <VendorsList />}
        {tab === 'pending' && <PendingVendors />}
      </div>
    </div>
  );
};

export default PartnerPanel;
